/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645740535924,
	"notificationDetails": {"updateType":"OPTION_FILTER_FAILED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TIGHT_SPREAD_CENTS",
	"statusDetails": {"cents":0.13},
	"date": "2022-02-24T17:08:56.620-0500",
	"timestamp": "1645740536624"
}
 * @param {*} statusDetails 
 * @returns an object with field cents that the user configured his tight spread cents filter for
 */
export function tightSpreadCentsParser(statusDetails) {
  const parsedObj = {
    cents: null,
  };
  if (statusDetails) {
    parsedObj.cents = statusDetails.cents ?? null;
  }

  return parsedObj;
}
